import React, { Component } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
// import { Link as ScrollLink } from 'react-scroll';
import media from 'src/styles/media';

import ScrollAnimation from 'components/ScrollAnimation';
import RegisterButton from 'src/components/RegisterButton';
import CircularImage from 'src/components/CircularImage';
import NextLine from 'src/components/NextLine';
import DownArrow from 'src/components/DownArrow';
import { VideoPopUp } from 'src/components/VideoPopUp';

import imgMainTower from 'src/assets/images/main-tower.png';
import imgLogo from 'src/assets/images/618-logo.svg';
import imgAerial from 'src/assets/images/neighbourhood/aerial.jpg';
import imgArrowRight from 'src/assets/images/button-arrow-right.png';
import imgBackgroundCircle from 'src/assets/images/background-circle.svg';
import imgHistory from 'src/assets/images/circle_legacy.jpg';
import imgLocation from 'src/assets/images/circle_location.jpg';
import imgInteriors from 'src/assets/images/circle_interiors.jpg';
import imgFloorplans from 'src/assets/images/circle_floorplan.jpg';
import imgViews from 'src/assets/images/circle_views.jpg';

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isPopUpOpen: false,
    };
  }

  render() {
    return (
      <Root>
        {this.state.isPopUpOpen ? (
          <VideoPopUp
            videoLink="https://player.vimeo.com/external/670383960.hd.mp4?s=4fd8e3e71df2b0e5e2764fb7be8d053ec54da9e1&profile_id=175"
            fileExtension="mp4"
            onClick={() => this.setState({ isPopUpOpen: false })}
          />
        ) : null}
        <DesktopDownArrow />
        <Header>
          <Content>
            <img src={imgLogo} alt="618 Carnarvon" />
            <h1>
              Studio, 1, 2 &amp; 3 Bedroom
              <br />
              Homes and Townhomes in
              <br />
              New Westminster
            </h1>
            {/* <StyledScrollLink to="discover" smooth>
              Discover More
            </StyledScrollLink> */}
            <StyledPopUpButton
              onClick={() => this.setState({ isPopUpOpen: true })}
            >
              Watch Video
            </StyledPopUpButton>
            <MobileDownArrow />
          </Content>
          <MainImage image={imgMainTower} />
        </Header>

        <ScrollAnimation>
          <Discover id="discover">
            <BackgroundCircle2
              src={imgBackgroundCircle}
              alt="background circle"
            />
            <CircleText>
              <h2>33 Storeys Above it All</h2>
              <p>
                An established neighbourhood connecting a rich past to a modern
                downtown lifestyle - 618 Carnarvon provides an elevated
                lifestyle in the heart of New Westminster.
              </p>
              <DesktopCircularImage
                image={imgHistory}
                outerheader={'A Rich History'}
                outertext={'An original Western Canadian city'}
                rotate={0}
                top={'-30%'}
                left={'-75%'}
                to={'legacy'}
              />
              <DesktopCircularImage
                image={imgLocation}
                outerheader={'New Westminster'}
                outertext={'Traditionally Romantic'}
                top={'55%'}
                left={'95%'}
                rotate={180}
                to={'neighbourhood'}
              />
            </CircleText>
            <MobileCircularImage
              image={imgHistory}
              outerheader={'A Rich History'}
              outertext={'An original Western Canadian city'}
              rotate={0}
              to={'legacy'}
            />
            <MobileCircularImage
              image={imgLocation}
              outerheader={'New Westminster'}
              outertext={'Traditionally Romantic'}
              rotate={180}
              to={'neighbourhood'}
            />
            <BackgroundCircle
              src={imgBackgroundCircle}
              alt="background circle"
            />
          </Discover>
        </ScrollAnimation>

        <ScrollAnimation>
          <ImageContent image={imgAerial}>
            <Link to="/building">
              <h3>Community Experience</h3>
              <p>
                The building features family residences, townhomes, and
                street-level shops.
              </p>
              <img src={imgArrowRight} alt="Arrow right" />
            </Link>
          </ImageContent>
        </ScrollAnimation>

        <ScrollAnimation>
          <CircleContent>
            <CircularImage
              image={imgInteriors}
              innerheader={'Classic Design'}
              innertext={'Interiors'}
              rotate={-45}
              to={'interiors'}
            />
            <CircularImage
              image={imgFloorplans}
              innerheader={'Open Spaces'}
              innertext={'Floorplans'}
              rotate={-135}
              to={'floorplans'}
            />
            <CircularImage
              image={require('src/assets/images/virtualtour/618_Carnarvon_Lobby_1-min.jpg')}
              innerheader={'Display Suites & Sales Centre'}
              innertext={'Virtual Tours'}
              rotate={45}
              to={'virtualtours'}
            />
            <CircularImage
              image={imgViews}
              innerheader={'Legendary Views'}
              innertext={'Views'}
              rotate={135}
              to={'views'}
            />
          </CircleContent>
        </ScrollAnimation>
        <NextLine text={'Next: The Legacy'} link={'legacy'} />
        <RegisterButton />
      </Root>
    );
  }
}

export default Home;

const Root = styled.div`
  overflow: hidden;
`;

const Header = styled.div`
  height: auto;
  display: flex;
  flex-direction: column;
  @media (min-width: ${media.smup}) {
    flex-direction: row;
    height: 100vh;
  }
`;

const BackgroundCircle = styled.img`
  top: 80%;
  width: 100%;
  position: absolute;
  z-index: -1;
  left: -30%;
  opacity: 0.7;
  @media (min-width: ${media.sm}) {
    width: 40%;
    display: block;
    top: 70%;
    left: -15%;
  }
`;

const BackgroundCircle2 = styled(BackgroundCircle)`
  display: none;
  @media (min-width: ${media.sm}) {
    z-index: -1;
    width: 40%;
    display: block;
    top: -30%;
    right: -15%;
    left: inherit;
    opacity: 0.7;
  }
`;

const MobileCircularImage = styled(CircularImage)`
  @media (min-width: ${media.smup}) {
    display: none;
  }
`;

const DesktopCircularImage = styled(CircularImage)`
  display: none;
  @media (min-width: ${media.smup}) {
    display: block;
  }
`;

const MobileDownArrow = styled(DownArrow)`
  @media (min-width: ${media.smup}) {
    display: none;
  }
`;

const DesktopDownArrow = styled(DownArrow)`
  display: none;
  @media (min-width: ${media.smup}) {
    display: block;
    z-index: 1;
  }
`;

const Content = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 25% 0;
  position: relative;
  @media (min-width: ${media.smup}) {
    width: 50%;
    padding: 0;
  }
  h1 {
    color: ${({ theme }) => theme.colorPrimary};
    font-family: ${({ theme }) => theme.fontHeader};
    font-weight: 500;
    font-size: 22px;
    text-align: center;
    text-transform: uppercase;
    margin: 80px 0;
    line-height: 32px;
  }
`;

// const StyledScrollLink = styled(ScrollLink)`
//   color: rgba(0, 0, 0, 0.83);
//   font-family: ${({ theme }) => theme.fontHeader};
//   font-size: 12px;
//   text-transform: uppercase;
//   width: 132px;
//   height: 35px;
//   border-radius: 30px;
//   box-shadow: 0 0 8px 0px rgba(0, 0, 0, 0.2);
//   cursor: pointer;
//   display: flex;
//   align-items: center;
//   justify-content: center;
// `;

const StyledPopUpButton = styled.button`
  color: rgba(0, 0, 0, 0.83);
  font-family: ${({ theme }) => theme.fontHeader};
  font-size: 12px;
  text-transform: uppercase;
  width: 132px;
  height: 35px;
  border-radius: 30px;
  box-shadow: 0 0 8px 0px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Discover = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  margin: 40px 0;
  @media (min-width: ${media.smup}) {
    flex-direction: row;
    height: 90vh;
    margin: 60px 0;
  }
`;

const CircleText = styled.div`
  width: 375px;
  height: 375px;
  padding: 20px;
  border: 1px solid ${({ theme }) => theme.colorLightGrey};
  border-radius: 50%;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 550px;
    height: 550px;
    border: 1px solid ${({ theme }) => theme.colorLightGrey};
    transform: translate(-50%, -50%);
    border-radius: 50%;
  }
  h2 {
    text-transform: uppercase;
    color: ${({ theme }) => theme.colorPrimary};
    font-family: ${({ theme }) => theme.fontHeader};
    margin-bottom: 30px;
    font-weight: 500;
  }
  p {
    font-family: ${({ theme }) => theme.fontMain};
    opacity: 0.72;
    font-size: 18px;
    line-height: 24px;
  }
`;

const ImageContent = styled.div`
  background-image: url(${(props) => props.image});
  background-position: center;
  background-size: cover;
  height: 60vw;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  @media (min-width: ${media.smup}) {
    height: 50vw;
  }
  a {
    background-color: ${({ theme }) => theme.colorDarkBlue};
    width: 283px;
    height: 283px;
    padding: 5px;
    border-radius: 50%;
    color: white;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    position: absolute;
    left: 50%;
    top: 100%;
    transform: translate(-50%, -50%);
    @media (min-width: ${media.smup}) {
      position: relative;
      transform: translate(0);
      left: 0;
      top: 0;
      margin: 0;
    }
    h3 {
      color: ${({ theme }) => theme.colorPrimary};
      font-family: ${({ theme }) => theme.fontHeader};
      font-size: 20px;
      font-weight: 500;
      text-transform: uppercase;
      margin: 10px 0;
    }
    p {
      font-family: ${({ theme }) => theme.fontMain};
      max-width: 200px;
      font-size: 18px;
      line-height: 20px;
    }
    img {
      position: absolute;
      bottom: -20px;
    }
  }
`;

const CircleContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin: 150px auto;
  @media (min-width: ${media.smup}) {
    width: 90%;
    align-items: center;
  }
  @media (min-width: 1100px) {
    width: 95%;
    flex-direction: row;
    justify-content: space-around;
  }
  @media (min-width: ${media.mdup}) {
    width: 95%;
  }
  @media (min-width: ${media.lgup}) {
    width: 80%;
  }
  a {
    padding: 20px 0;
    @media (min-width: ${media.smup}) {
      padding: 0;
      margin-bottom: 5%;
      &:last-child {
        margin-bottom: 0;
      }
    }
    @media (min-width: 1100px) {
      margin-bottom: 0;
    }
  }
`;

const MainImage = styled.div`
  background-image: url('${(props) => props.image}');
  background-size: cover;
  background-position: center;
  display: block;
  width: 100%;
  height: 130vw;
  margin-bottom: 25%;
  @media (min-width: ${media.smup}) {
    width: 50%;
    height: auto;
    margin-bottom: 0;
  }
`;



// WEBPACK FOOTER //
// ./src/pages/Home.js